import { ICommonTutorialTypes } from '@/store/types';
import { ITutorialTypeAdmin } from '@/store/types.admin';
import { createSliceSteamup } from '../common';

interface ITutorialCategoryManageState {
  loading: boolean;
  tutorialCategory: ICommonTutorialTypes[];
}

const tutorialCategoryManageSlice = createSliceSteamup(
  'tutorialCategory',
  {
    loading: false,
    tutorialCategory: [],
  } as ITutorialCategoryManageState,
  {

  },
);

export default tutorialCategoryManageSlice;
